import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerPhotosComponent } from './customer-photos.component';
import { TableModule } from 'primeng';

const routes: Routes = [{ path: '', component: CustomerPhotosComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerPhotosRoutingModule {}

@NgModule({
  imports: [
    CustomerPhotosRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [CustomerPhotosComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerPhotosModule {}
